import { EmptyContentMessage } from '@/components/layout/empty-content-message';
import { useTranslations } from 'next-intl';
import { asideBetslipStyle } from './aside-bet-slip.style';

export const AsideEmptyPage = () => {
	const t = useTranslations('General');
	return (
		<>
			<EmptyContentMessage 
				type={'bets'} 
				title={t('lbl_emptybetslip01')}
			>
				<div className={asideBetslipStyle.text}>
					{t('lbl_emptybetslip02')}
				</div>
			</EmptyContentMessage>
		</>
	);
}